import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appItemLeadingActionsContent]',
  standalone: true,
})
export class ItemLeadingActionsContentDirective {
  readonly templateRef = inject(TemplateRef<unknown>);
}
